import { useTaal } from "@/contexts/TaalContext";
import { EN, NL } from "@/lib/taal";
import { cn } from "@/lib/utils";

/**
 * NL | EN, NL/EN-batch A1. Twee knoppen en geen keuzelijst: de gekozen taal is
 * in een oogopslag te zien, en omschakelen is een tik. Werkt meteen, zonder
 * opslaan-knop; de keuze gaat naar de server en geldt ook op de telefoon.
 */
export default function TaalSchakelaar({ compact = false, className }) {
  const { taal, zetTaal, t } = useTaal();
  const knop = (code, label) => (
    <button
      type="button"
      onClick={() => taal !== code && zetTaal(code)}
      aria-pressed={taal === code}
      aria-label={t(`taal.${code}`)}
      data-testid={`taal-${code}`}
      className={cn(
        "tap-target rounded px-2 py-1 text-xs font-medium transition-colors",
        taal === code ? "bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]" : "text-muted-foreground hover:text-foreground"
      )}
    >
      {label}
    </button>
  );
  return (
    <div
      role="group"
      aria-label={t("taal.kies")}
      data-testid="taal-schakelaar"
      className={cn("flex items-center gap-1", !compact && "px-2", className)}
    >
      {!compact && <span className="mr-auto text-xs text-muted-foreground">{t("taal.kies")}</span>}
      {knop(NL, "NL")}
      {knop(EN, "EN")}
    </div>
  );
}
